import { useQuery } from "@tanstack/react-query";
import { fetchMembers } from "@/api/member";
import { useRequiredOrgId } from "@/hooks/useRequiredOrgId";
import { queryKeys } from "@/lib/query-keys";

export const useMembers = () => {
  const organizationId = useRequiredOrgId();

  return useQuery({
    queryKey: queryKeys.members.all(organizationId),
    queryFn: () => fetchMembers(organizationId),
    enabled: !!organizationId,
  });
};
